module.exports = __webpack_public_path__ + "static/media/1009772.98fe17b0.jpg";